'use client';

import ResponsiveImage from '@/components/ResponsiveImage';
import Swiper from '@/components/Swiper/Swiper';
import { useRef } from 'react';

export default function Covers({ list = [] }) {
  const swiperRef = useRef(null);

  if (!list.length) return <></>;

  return (
    <div className='covers flex flex-col gap-2 sm:[&_.swiper-pagination]:hidden sm:[--swiper-padding-bottom:0]'>
      <Swiper breakpoints={{}} ref={swiperRef}>
        {list.map((cover, index) => (
          <div key={index} className='relative h-full max-h-[25rem] border border-primary rounded-lg overflow-clip'>
            <ResponsiveImage file={cover} priority className='h-full object-cover' />
            <div className='body1 isolate absolute z-10 bottom-0 p-4 inset-x-0'>
              <div className='absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/5' />
              <div className='relative z-10 text-white text-center'>{cover.alternativeText}</div>
            </div>
          </div>
        ))}
      </Swiper>

      <div className='hidden sm:flex gap-2 flex-wrap'>
        {list.map((cover, index) => (
          <ResponsiveImage
            key={index}
            file={cover}
            priority
            className='h-full object-cover rounded-lg size-[4rem] border border-primary'
            onClick={() => {
              const { swiper } = swiperRef.current;
              swiper.slideTo(index);
            }}
          />
        ))}
      </div>
    </div>
  );
}
